import React from "react";
import { apiPut } from "../../../utils/apiFetch";
import apiPath from "../../../utils/apiPath";
import { isEmpty } from "lodash";
import dayjs from "dayjs";
import useToastContext from "hooks/useToastContext";
import { AiFillEye } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { BsArrowUpShort } from "react-icons/bs";
import helper from "../../../utils/helpers";

const HiringList = ({ formsManager, getFormsManager, handleUserView, user, page, sort, setSort, manager }) => {
  const { t } = useTranslation();
  const notification = useToastContext();
  const handelStatusChange = async (item) => {
    try {
      const payload = {
        status: item?.status === "inactive" ? "active" : "inactive",
      };
      const path = `${apiPath.changeFormsStatus}/${item?.formType}`;
      const result = await apiPut(path, payload);
      if (result?.status === 200) {
        notification.success(result.data.message);
        getFormsManager();
      }
    } catch (error) {
      console.log("error in get all forms list==>>>>", error.message);
    }
  };

  return (
    <div className="p-3">
      <div className="overflow-x-auto relative rounded-lg border">
        <table className="w-full text-xs text-left text-[#6c6c6c] dark:text-gray-400 ">
          <thead className="text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400">
            <tr>
              <th scope="col" className="py-3 px-6">
                Sr no.
              </th>
              <th className="py-3 px-6" scope="col">
                {t("TITLE")}
              </th>
              <th
                scope="col"
                className="px-6 cursor-pointer py-3 "
                onClick={() => {
                  const newSortType = sort.sortType === "asc" ? "desc" : "asc";
                  setSort({
                    sortBy: "createdAt",
                    sortType: newSortType,
                  });
                }}
              >
                <div className="flex justify-start">
                  <span>{t("CREATED_DATE")}</span>
                  <span>{sort.sortBy === "createdAt" && <BsArrowUpShort className={`w-4 h-4 ${sort.sortType === "asc" ? "" : "rotate-180"}`} />}</span>
                </div>
              </th>
              {/* <th scope="col" className="py-3 px-6 text-center">
                {t("O_STATUS")}
              </th> */}
              <th scope="col" className="py-3 px-6 text-center">
                {t("O_ACTION")}
              </th>
            </tr>
          </thead>
          <tbody>
            {formsManager &&
              formsManager?.map((item, i) => (
                <tr key={i} className="bg-white border-b dark:bg-gray-800 dark:border-gray-700">
                  <th scope="row" className="py-4 px-6 border-r font-medium text-gray-900  dark:text-white">
                    {i + 1 + 10 * (page - 1)}
                  </th>
                  <td className="py-4 px-6 border-r text-gray-900">{item?.formName} </td>
                  <td className="py-4 px-6 border-r text-gray-900 ">{dayjs(item?.createdAt).format("MM-DD-YYYY hh:mm A")} </td>

                  {/* <td className="py-4 px-6 border-r text-center text-gray-900">
                    <label className="inline-flex relative items-center cursor-pointer" title={`${item?.status === "active" ? "Active" : "Inactive"}`}>
                      <input
                        checked={item?.status === "active"}
                        type="checkbox"
                        className="sr-only peer"
                        onChange={(e) => helper.alertFunction(`Are you sure you want to ${e.target.checked ? "active" : "inactive"} '${item.formName}'?`, item, handelStatusChange)}
                      />
                      <div className="rounded-full peer peer-focus:ring-0 w-10 h-5 bg-gray-200 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all dark:border-gray-600 peer-checked:bg-LightBlue" />
                    </label>
                  </td> */}

                  <td className="text-gray-900 py-4 px-6 border-l ">
                    <div className="">
                      <ul className="flex justify-center">
                        {(manager?.view || user?.role === "admin") && (
                          <li onClick={() => handleUserView(item?._id)} className="px-2 py-2 hover:text-LightBlue hover:bg-white ">
                            <a title={t("VIEW_FORMS")}>
                              {" "}
                              <AiFillEye className="cursor-pointer w-5 h-5 text-slate-600" />{" "}
                            </a>
                          </li>
                        )}
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
            {isEmpty(formsManager) ? (
              <tr className="text-center border-b bg-white dark:bg-gray-800 dark:border-gray-700">
                <td className="py-4 px-6 border-r" colSpan={5}>
                  {t("O_NO_RECORD_FOUND")}
                </td>
              </tr>
            ) : null}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default HiringList;
